module.exports = __webpack_public_path__ + "img/close_x.4bb4c2b1.svg";